import { Constants } from './constants';

export function filterVehicleStatusesForCurrentVehicle<T extends { name: string }>(statuses: T[], currentStatusCaption: string): T[]
{
    if (currentStatusCaption === Constants.Vehicle_Status_Sold_Caption)
    {
        return statuses.filter(status => status.name === Constants.Vehicle_Status_Sold_Caption);
    }

    return statuses.filter(status => status.name !== Constants.Vehicle_Status_Sold_Caption);
}
